import React, { createContext, useState, useRef, useEffect } from 'react';
import { useAuth } from '../../AuthContext';
import useApi from '../../Api';

const QuestionnaireContext = createContext();

export const QuestionnaireProvider = ({ children }) => {
  const [answers, setAnswers] = useState({});
  const scrollPositionRef = useRef(0);
  const lastUserRef = useRef(null);

  const { user, token } = useAuth();
  const apiClient = useApi();
  const MAX_RETRIES = 3;

  const loadPreferences = async (retryCount = 0) => {
    try {
      const response = await apiClient.get('/explore/user_preferences', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const prefs = response.data.preferences || {};
      setAnswers((prev) => ({ ...prev, ...prefs }));
    } catch (error) {
      if (
        error.response &&
        error.response.status === 403 &&
        retryCount < MAX_RETRIES
      ) {
        console.warn(
          `Preferences not yet set. Retrying in 2 seconds... (${retryCount + 1}/${MAX_RETRIES})`
        );
        setTimeout(() => loadPreferences(retryCount + 1), 2000);
      } else {
        console.error('Failed to load user preferences:', error);
      }
    }
  };

  useEffect(() => {
    if (user && token) {
      const currentUserEmail = user.email || '';
      if (lastUserRef.current !== currentUserEmail) {
        lastUserRef.current = currentUserEmail;
        loadPreferences();
      }
    }
  }, [user, token, apiClient]);

  return (
    <QuestionnaireContext.Provider value={{ answers, setAnswers, scrollPositionRef }}>
      {children}
    </QuestionnaireContext.Provider>
  );
};

export default QuestionnaireContext;
